export const AUTOCOMPLETE = 'autocomplete';
export const PAXPICKER = 'paxpicker';
export const CITYPICKER = 'citypicker';
export const DATEPICKER = 'datepicker';
export const SET_ACTIVE_INDEX = 'setActiveIndex';
export const CLEAR_ACTIVE_INDEX = 'clearActiveIndex';
export const DEFAULT_PAX_VALUE = [
  {
    adults: 2,
  },
];
export const DEFAULT_ROOM_LISTING = [
  {
    noOfAdults: 2,
    noOfChildrenWOB: 0,
    noOfChildrenWB: 0,
    noOfInfants: 0,
    listOfAgeOfChildrenWB: [],
  },
];
export const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];
export const MONTHS_NUM = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
export const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export const GEO_LOCATION_STORAGE = 'geoLocation';

export const AUTO_DETECT = 'Auto Detect';
export const CURR_LOCATION = 'Use Current Location';
export const FROM_MANUAL = 'Manual';

export const FROM_SUGGEST = 'suggest';

export const CITY_TYPE = {
  AIRPORT: 'Airport',
  NON_AIRPORT: 'Non Airport',
};

export const MESSAGE_TEMPLATE = {
  CITY_SHOWN: 'City shown',
  NEARBY_CITY_SHOWN: 'Nearby City shown',
  NO_CITY: 'No City',
};

export const COUNTRY_CODES = {
  IN: 'IN',
  US: 'US',
  AE: 'AE',
};
const { IN, US, AE } = COUNTRY_CODES;
export const DOMAINS = {
  [IN]: 'makemytrip.com',
  [US]: 'makemytrip.us',
  [AE]: 'makemytrip.ae',
};
